import { useNavigate } from "react-router-dom";

const highlights = [
  { icon: "ri-truck-line", title: "整车整柜采购", desc: "支持大批量整车、整柜采购需求发布，直连认证工厂" },
  { icon: "ri-eye-off-line", title: "信息完全保密", desc: "采购详情对公众隐藏，仅认证付费工厂会员可见" },
  { icon: "ri-building-4-line", title: "认证工厂报价", desc: "只有通过严格认证的工厂才能查看并提交报价" },
  { icon: "ri-bank-line", title: "货款平台托管", desc: "确认收到高品质商品后，货款才会释放给工厂" },
];

const sampleCategories = [
  { name: "家居用品", icon: "ri-home-4-line", count: "128条需求" },
  { name: "服装鞋包", icon: "ri-t-shirt-line", count: "96条需求" },
  { name: "电子数码", icon: "ri-smartphone-line", count: "74条需求" },
  { name: "运动户外", icon: "ri-run-line", count: "52条需求" },
  { name: "母婴玩具", icon: "ri-bear-smile-line", count: "43条需求" },
  { name: "食品农产品", icon: "ri-restaurant-line", count: "38条需求" },
];

export default function BuyerRfqSection() {
  const navigate = useNavigate();

  return (
    <section className="py-12 md:py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="flex flex-col lg:flex-row items-start justify-between gap-5 mb-8 md:mb-10">
          <div>
            <span className="inline-block bg-red-100 text-red-500 text-xs px-3 py-1 rounded-full mb-3 md:mb-4 font-medium">
              <i className="ri-truck-line mr-1"></i> 买家采购需求中心
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2 md:mb-3" style={{ fontFamily: "'Noto Serif SC', serif" }}>
              大批量采购？发布需求，<br />
              <span className="text-red-500">让认证工厂主动报价</span>
            </h2>
            <p className="text-gray-500 text-sm md:text-base max-w-lg leading-relaxed">
              发布整车、整柜采购需求，平台推送给所有认证工厂。
              您的采购信息完全保密，仅已付费认证工厂可见，保护您的商业隐私。
            </p>
          </div>
          <div className="flex flex-row lg:flex-col gap-3 w-full lg:w-auto flex-shrink-0">
            <button
              onClick={() => navigate("/buyer-rfq")}
              className="flex-1 lg:flex-none bg-red-500 hover:bg-red-600 text-white px-6 md:px-8 py-3.5 md:py-4 rounded-2xl font-bold text-sm md:text-base transition-all cursor-pointer whitespace-nowrap text-center"
            >
              <i className="ri-add-circle-line mr-2"></i>发布采购需求
            </button>
            <button
              onClick={() => navigate("/factory-quotes")}
              className="flex-1 lg:flex-none border border-gray-200 hover:bg-gray-100 text-gray-600 px-6 md:px-8 py-3 rounded-2xl font-medium text-sm transition-colors cursor-pointer whitespace-nowrap text-center"
            >
              <i className="ri-building-4-line mr-1"></i>工厂查看报价
            </button>
          </div>
        </div>

        {/* Highlights */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 mb-8 md:mb-10">
          {highlights.map((h) => (
            <div key={h.title} className="bg-white rounded-2xl p-4 md:p-5 flex flex-col gap-2 md:gap-3">
              <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-red-50 rounded-xl">
                <i className={`${h.icon} text-red-500 text-lg md:text-xl`}></i>
              </div>
              <div>
                <p className="text-gray-800 font-semibold text-xs md:text-sm">{h.title}</p>
                <p className="text-gray-400 text-xs mt-1 leading-relaxed hidden sm:block">{h.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Privacy notice + category preview */}
        <div className="flex flex-col lg:flex-row gap-5 md:gap-6">
          {/* Privacy box */}
          <div className="lg:w-80 flex-shrink-0 bg-amber-50 border border-amber-200 rounded-2xl p-5 md:p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-amber-100 rounded-xl">
                <i className="ri-lock-line text-amber-600 text-lg md:text-xl"></i>
              </div>
              <h3 className="text-gray-800 font-bold text-sm">隐私保护机制</h3>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-2 md:gap-3">
              {[
                { icon: "ri-eye-off-line", text: "采购价格、数量对公众完全隐藏" },
                { icon: "ri-user-forbid-line", text: "未认证工厂无法查看任何报价信息" },
                { icon: "ri-shield-check-line", text: "仅已付费认证工厂会员可见" },
                { icon: "ri-file-lock-line", text: "平台不会泄露您的联系方式" },
                { icon: "ri-bank-line", text: "货款托管，确认质量后才放款" },
              ].map((item) => (
                <div key={item.text} className="flex items-start gap-2.5">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-amber-500 text-sm`}></i>
                  </div>
                  <span className="text-gray-600 text-xs leading-relaxed">{item.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Category grid */}
          <div className="flex-1">
            <div className="flex items-center justify-between mb-3 md:mb-4">
              <h3 className="text-gray-700 font-semibold text-sm">热门采购品类</h3>
              <button
                onClick={() => navigate("/buyer-rfq")}
                className="text-red-500 text-xs hover:underline cursor-pointer whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </button>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 md:gap-3">
              {sampleCategories.map((cat) => (
                <button
                  key={cat.name}
                  onClick={() => navigate("/buyer-rfq")}
                  className="bg-white rounded-xl p-3 md:p-4 flex items-center gap-2.5 md:gap-3 hover:border-red-200 border border-transparent transition-all cursor-pointer text-left"
                >
                  <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-red-50 rounded-xl flex-shrink-0">
                    <i className={`${cat.icon} text-red-500 text-base md:text-lg`}></i>
                  </div>
                  <div>
                    <p className="text-gray-800 font-semibold text-xs md:text-sm">{cat.name}</p>
                    <p className="text-gray-400 text-xs mt-0.5">{cat.count}</p>
                  </div>
                </button>
              ))}
            </div>

            {/* CTA strip */}
            <div className="mt-3 md:mt-4 bg-gradient-to-r from-red-500 to-orange-500 rounded-xl p-4 flex items-center justify-between gap-4">
              <div className="text-white">
                <p className="font-bold text-sm">工厂会员专属权益</p>
                <p className="text-white/75 text-xs mt-0.5 hidden sm:block">认证工厂才能查看买家报价，前3个月免费</p>
              </div>
              <button
                onClick={() => navigate("/factory-quotes")}
                className="bg-white text-red-500 hover:bg-red-50 px-4 md:px-5 py-2 rounded-xl font-bold text-sm transition-all cursor-pointer whitespace-nowrap flex-shrink-0"
              >
                查看报价
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
